import { render, staticRenderFns } from "./manageReferral.pug?vue&type=template&id=1bcb5c7e&lang=pug&"
import script from "./manageReferral.ts?vue&type=script&lang=ts&"
export * from "./manageReferral.ts?vue&type=script&lang=ts&"
import style0 from "./manageReferral.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports